export default {
  translation: {
    'shared.french': 'French',
    'shared.english': 'English'
  }
};
